import ReactGoogleAutocomplete from "react-google-autocomplete"
import { maps_key, url_images } from "../../lib/backend/data"
import { obtenerGeoDatosGoogle } from "../../lib/helpers/pedidos/pedidos"
import { FaCheckCircle, FaEdit, FaList, FaRegClock, FaRegStickyNote } from "react-icons/fa"
import { actualizarDireccion, agregarDireccion, removeAddress } from "../../redux/actions/direcciones"
import { BiTrash } from "react-icons/bi"
import { useLocation } from "react-router-dom"
import { Dialog } from "@mui/material"
import { IoMdClose } from "react-icons/io"
const { useEffect, useState, useRef } = require("react")
const { useSelector, useDispatch } = require("react-redux")
const { refrescarUser } = require("../../redux/actions/user")
const { MdPlace, MdEdit, MdOutlinePlace } = require("react-icons/md")
const { Modal, Button, Row, Col, Card } = require("react-bootstrap")

const DireccionUsuario = (props) => {
    const {
        typeView
    } = props
    const user = useSelector(state => state.user)
    const userRef = useRef(user)
    const [showModal, setShowModal] = useState(false)
    const location = useLocation()
    const [direccion, setDireccion] = useState(null)
    const direcciones = useSelector(state => state.direcciones)
    const dispatch = useDispatch()

    useEffect(() => {
        userRef.current = user
    }, [user])

    const handleClose = () => {
        setShowModal(false)
        const instancia = JSON.parse(JSON.stringify(userRef.current))
        instancia.dismiss = true
        dispatch(refrescarUser(instancia))
    }

    function generarUID() {
        // Usamos Luxon para obtener una marca de tiempo formateada, o bien puedes usar Date.now()
        // const fecha = DateTime.now().toFormat("yyyyLLddHHmmss");
        const fecha = new Date().toISOString().replace(/[-:.TZ]/g, ""); // formato: YYYYMMDDHHMMSSmmm
      
        // Generamos una parte aleatoria en base a un número random convertido a base 36
        const randomPart = Math.random().toString(36).substring(2, 10);
      
        // Concatenamos la marca de tiempo y la parte aleatoria para formar el UID
        return `${fecha}-${randomPart}`;
      }

    const consultarDireccion = () => setShowModal(true)

    const verificarUsuario = () => {
        if(userRef.current?.billing?.address_1) return false
        if(userRef.current?.dismiss !== true ) return consultarDireccion()
    }

    const cambioDireccion = (place, address) => {
        
        
        const instancia = JSON.parse(JSON.stringify(userRef.current))

        if(instancia.billing.address_1 === place.formatted_address){
            return setDireccion(address)
        }
        const geo_informacion = obtenerGeoDatosGoogle(place)
        if(typeof geo_informacion?.lat === "function" || geo_informacion.lat === 0){
            geo_informacion.lat = place.geometry.location.lat()
            geo_informacion.lng = place.geometry.location.lng()
        }

                            let geo_data = {
                                            level1: geo_informacion.level1 ?  geo_informacion.level1 : "",
                                            level2: geo_informacion.level2 ?  geo_informacion.level2 : "",
                                            pais: geo_informacion.pais ? geo_informacion.pais : "",
                                            level3: geo_informacion.level3 ? geo_informacion.level3 : "",
                                            formatted_address: geo_informacion.formatted_address ? geo_informacion.formatted_address : "",
                                            lat: geo_informacion.lat,
                                            lng: geo_informacion.lng,
                                            place,
                                            postal_code: geo_informacion.postal_code
                                        }
                                        console.log(geo_data, geo_informacion)

                            let region = ''
                            const buscar_region = place.address_components.findIndex(comp => {
                                return comp.types.includes('administrative_area_level_1')
                            })
                            if(buscar_region > -1) region = place.address_components[buscar_region].long_name

                            let comuna = ''
                            const buscar_comuna = place.address_components.findIndex(comp => {
                                return comp.types.includes('administrative_area_level_2')
                            })
                            if(buscar_comuna > -1) comuna = place.address_components[buscar_comuna].long_name

                            const id = generarUID()
                            const direccion = {
                                id,
                                formated_address: place.formatted_address,
                                geo_data,
                                place
                            }
                            

                            instancia.id_ubicacion = id
                            instancia.billing.address_1 = place.formatted_address
                            instancia.geo_datos = geo_data
                            instancia.location = {
                                type: "Point",
                                coordinates: [
                                    geo_data.lng, geo_data.lat
                                ]
                            }
                            console.log(direccion, instancia)
                            dispatch(agregarDireccion(direccion))
                            dispatch(refrescarUser(instancia))
                            setShowModal(false)
                            setDireccion(direccion)
    }

    const eliminarDireccion = (address) => {
        setDireccion(false)
        const instancia = JSON.parse(JSON.stringify(userRef.current))
        delete instancia.id_ubicacion
        delete instancia.billing.address_1
        delete instancia.geo_datos
        delete instancia.location
        dispatch(refrescarUser(instancia))
        dispatch(removeAddress(address))
    }

    const handleChangeDireccion = (e) => {
        const { value, name } = e.target
        return setDireccion(prev => {
            let actual = {...prev}
            actual[name] = value
            dispatch(actualizarDireccion(actual))
            return actual
        })
    }

    const seleccionarDireccion = (place, address) => {
         const instancia = JSON.parse(JSON.stringify(userRef.current))

        if(instancia.billing.address_1 === place.formatted_address){
            return setDireccion(address)
        } else {
            cambioDireccion(place, address)
        }
    }

    const mostrarDirecciones = () => {
        if(direccion){
            const i = direcciones.findIndex(dire => dire?.id === direccion?.id)
            if(i > -1) {
                const address = direcciones[i]
                return <Card className="p-2 mb-3">
                    <Row>
                        <Col md={10}><h6>{address.formated_address}</h6></Col>
                        <Col md={2} className="text-right"><MdEdit /></Col>
                    </Row>
                    <h6>Tipo de edificio</h6>
                    <select className="form-control mb-3" name="tipo" value={address.tipo} onChange={handleChangeDireccion}>
                        <option value="">Seleccione</option>
                        <option value="casa">Casa</option>
                        <option value="departamento">Departamento</option>
                        <option value="oficina">Oficina</option>
                        <option value="hotel">Hotel</option>
                        <option value="otro">Otro</option>
                    </select>
                    <h6>Depto./Oficina/Piso </h6>
                    <input className="form-control mb-3" name="address_2" value={address.address_2} placeholder="Ejemplo 1307" onChange={handleChangeDireccion}></input>

                    <h6>Nombre de la empresa o del edificio</h6>
                    <input className="form-control mb-3" name="depto" value={address.depto} placeholder="Ejemplo Clínica Santa María" onChange={handleChangeDireccion}></input>

                    <h6><FaRegStickyNote /> Instrucciones y/o observaciones</h6>
                    <input className="form-control mb-3" name="notas" value={address.notas} placeholder="Puedes incluir instrucciones para encontrar la ubicación o para el repartidor" onChange={handleChangeDireccion} />
                    <Row>
                        <Col lg={6} xs={12}><Button className="w-100 mb-2" size="sm" onClick={() => cambioDireccion({ ...direccion.place, location: {
                                lat: direccion.place.geometry.location.lat,
                                lng: direccion.place.geometry.location.lng
                            } })}>GUARDAR</Button></Col>
                        <Col lg={6} xs={12}><Button className="w-100 mb-2" variant="light" size="sm" onClick={() => eliminarDireccion(address)}><FaEdit /> CAMBIAR ESTA DIRECCIÓN</Button></Col>
                    </Row>
                    
                </Card>            
            }
        }

        return <div>
            <Row>
                <Col xs={12}>
                <h3><MdOutlinePlace /> Dirección</h3>
                <label className="form-control-label d-block">Ingresa tu dirección para el despacho</label>
                <ReactGoogleAutocomplete
                            className="form-control mb-2"
                            id="direccion_select"
                            options={{
                                types: ["address"],
                                // cokmponentRestrictions: { country: pais },
                            }}                    
                            apiKey={maps_key}
                            onPlaceSelected={(place) => {
                                    if(!place) return false
                                    cambioDireccion(place)
                                    setTimeout(() => {
                                        const input = document.getElementById('direccion_select')
                                        if(input) {
                                            input.value = ""
                                        }
                                    }, 300);
                                }}
                            />
                            {/* <GeolocationComponent onSelect={(e) => {
                                if(e) {
                                    cambioDireccion(e)
                                    const input = document.getElementById('direccion_select')
                                    if(input) {
                                        input.value = e.formatted_address
                                    }
                                }
                                }} /> */}
                    { location.pathname !== "/checkout" ? <div>
                        <p style={{ fontSize:12 }}>¡Puedes definir esto luego!</p>
                        <Button variant="secondary" size="sm" onClick={() => handleClose()}><IoMdClose /> CERRAR</Button>
                    </div> : false }
                </Col>
            </Row>
            
          
            {
                direcciones.map((direccion, i) => {
                    const lugar = { ...direccion.place, location: {
                                lat: direccion.place.geometry.location.lat,
                                lng: direccion.place.geometry.location.lng
                    } }
                    return <div key={direccion.id} className="mb-3 hover">
                        <Card className="p-3 mb-3">
                        <Row justify="center" className="align-items-center">
                            <Col md={12} className="hover" onClick={() => seleccionarDireccion(lugar, direccion)}><h6 className="mb-0">{direccion.formated_address === user?.billing?.address_1 ? <div className="d-inline-block mr-1"><FaCheckCircle color="green" /> </div> : false}{direccion.formated_address}</h6></Col>
                        </Row>
                        </Card>
                    </div>
                })
            }
        </div>
    }

    const mostrarModal = () => {
        return <Dialog open={showModal} size="lg" fullWidth onClose={()=>handleClose()}
        centered
        >
        <div className="p-3">
        {mostrarDirecciones()}
        </div>
      </Dialog>
    }
    useEffect(() => {
        verificarUsuario()
        if(typeView === "checkout") {
            if(user?.billing?.address_1){
                const i = direcciones.findIndex(dire => dire?.formated_address === user?.billing?.address_1)
                if(i > -1) {
                    const address = direcciones[i]
                    setDireccion(address)
                }
            }
        }
    }, [])

    
    const mostrarDireccion = () => {
        const max = 50
        let size = null
        let address = "Ingrese su dirección"
        if(user?.billing?.address_1) address = `${user?.billing?.address_1.toString().substring(0, max)}${user?.billing?.address_1.length > max ? "..." : ""}`
        if(typeView === "checkout") return mostrarDirecciones()
        if(typeView === "icon") {
            address = ''
            size = 29
        }
        return <div onClick={() => consultarDireccion()}>
            <h6 className="mb-0 hover"  ><MdPlace size={size} /> {address}</h6>
        </div> 
    }

    return <div>
        {mostrarModal()}
        {mostrarDireccion()}
    </div>
}

export default DireccionUsuario